import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const BreakdownWrap = styled.div`
  margin-top: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px dashed ${tokens.border.hairline};
  max-width: 34rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const BreakdownTitle = styled.p`
  font-size: ${tokens.font.micro};
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${tokens.text.muted};
`

export const BreakdownCellText = styled.span<{ $em?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: ${({ $em }) => ($em ? 700 : 600)};
  color: ${({ $em }) => ($em ? tokens.text.primary : tokens.text.secondary)};
  font-variant-numeric: tabular-nums;
`
